import MeetingQuestionAnswer from './MeetingQuestionAnswer'

export default MeetingQuestionAnswer
